import {
  dehydrateApolloClient,
  getMaintainedParam,
  initApolloClient,
} from "../apolloClient";
import {
  GET_ALL_DIRECTIONS,
  GET_ALL_DISTRICTS,
} from "../../graphql/queries/regions";
import {
  FIND_LISTINGS,
  FIND_LISTINGS_WITH_SOV,
} from "@/graphql/queries/find.listings";

const isPage = new RegExp(/^[0-9]+$/);
export const City = {
  Resolve: async (ctx, $res) => {
    /**
     * Here I can query for listing by category,city and page if
     * it exists.
     * ctx: NextPageContext {req,query,...etc.}
     *
     * */
    const { cities } = await import("./ssr/cities");
    const { description } = await import("./ssr/categories");

    const [, city, page, plus] = ctx?.query?.params || [];
    if (!city) return {}; // break
    ctx.city = city;

    if (!cities[city]) throw ` مدينة غير موجودة `;

    ctx.path.city = cities[city];
    ctx.sov = {
      listing_category: ctx.path?.category?.id,
      city_id: ctx.path?.city?.id,
      enabled: true,
      campaign_category: "PROMOTED",
    };
    if (!ctx.path.category?.id || !ctx.path.city?.id) {
      ctx.sov = undefined;
    }
    const descriptionTemplate = description[ctx.path.category.uri];
    ctx.path.city.description = descriptionTemplate
      ? descriptionTemplate.replace(/%place/g, ctx.path.city.name)
      : `${ctx.path.category.name} في ${ctx.path.city.name}`;

    ctx.path.city.description = ctx.path.filtersAsText
      ? ctx.path.city.description + " " + ctx.path.filtersAsText
      : ctx.path.city.description;
    ctx.path.city.title = `${ctx.path.category?.plural} في ${ctx.path.city.name}`;
    ctx.path.city.path = `/${ctx.path.category.uri}/${ctx.path.city.uri}`;
    if (page && !isPage.test(page)) return {}; // resume to next;
    ctx.path.page = parseInt(page, 10);
    if (ctx.path.page === 1) {
      return ctx.redirect(ctx.req.url.replace(`/${page}`, ""));
    }
    if (plus) return {}; // resume to next;
    const client = initApolloClient();
    const pathFilters = ctx.path.filters || {};
    const { villa_type, ...filters } = pathFilters;
    const maintainedParam = getMaintainedParam(
      ctx.authState?.user?.cooperative,
    );
    const where = {
      city_id: {
        eq: ctx.path.city.id,
      },
      ...filters,
      ...(filters?.price_12_payments?.gte > 1
        ? {
            price_12_payments: { gte: filters.price_12_payments.gte * 12 },
          }
        : {}),
      ...(villa_type?.eq && { villa_type: villa_type.eq }),
      unpublished: undefined,
      ...maintainedParam,
    };

    if (ctx.path.category.id) {
      where.category = {
        eq: ctx.path.category.id,
      };
    }

    await Promise.all([
      client.query({
        query: ctx.sov ? FIND_LISTINGS_WITH_SOV : FIND_LISTINGS,
        context: { aqarPlus: ctx.authState?.token },
        variables: {
          size: 20,
          from: ((ctx.path.page || 1) - 1) * 20,
          sort: {
            create_time: "desc",
            has_img: "desc",
          },
          where,
          sov: ctx.sov,
          daily_renting_filter: ctx.path.daily_renting_filter,
        },
      }),
      client.query({
        query: ctx.path.city.directions
          ? GET_ALL_DIRECTIONS
          : GET_ALL_DISTRICTS,
        variables: {
          category: ctx.path.category.id,
          city_id: ctx.path.city.id,
        },
      }),
    ]);

    return $res(dehydrateApolloClient(client, {}));
  },
};
export default City;
